import React, {useState} from "react";

export default function OrganisationUnitFields(data = {}) {

  const allowEdit = (Object.entries(data).length > 0 && data.type_id_update_type === 27);

  return {
    name: {
      field: "input",
      label: "Name",
      required: true,
      disable: allowEdit,
      validation: "string|required",
      initial_value: (Object.entries(data).length > 0 && data.name !== null) ? data.name : ''
    },
    code: {
      field: "input",
      label: "Code",
      required: true,
      disable: allowEdit,
      validation: "string|required",
      initial_value: (Object.entries(data).length > 0 && data.code !== null) ? data.code : ''
    },
    type_id_organisation_unit_type: {
      field: "autocomplete",
      multi: false,
      option: "types",
      limiter: 'category_id|3',
      label: "Organisation Unit",
      required: true,
      disable: allowEdit,
      validation: "integer|required",
      initial_value: (Object.entries(data).length > 0 && data.type_id_organisation_unit_type !== null) ? data.type_id_organisation_unit_type : '',
      className: 'half'
    },
    organisation_unit_id_parent: {
      field: "autocomplete",
      multi: false,
      option: "organisation_unit",
      label: "Parent Organisation",
      disable: allowEdit,
      validation: "integer",
      initial_value: (Object.entries(data).length > 0 && data.organisation_unit_id_parent !== null) ? data.organisation_unit_id_parent : '',
      className: 'half'
    },
    parent_external_organisation_unit_identifier: {
      field: "input",
      label: "Parent External Organisation Unit Identifier",
      disable: allowEdit,
      initial_value: (Object.entries(data).length > 0 && data.parent_external_organisation_unit_identifier !== null) ? data.parent_external_organisation_unit_identifier : '',
      className: 'full'
    },
    external_organisation_unit_identifier: {
      field: "input",
      label: "External Organisation Unit Identifier",
      disable: allowEdit,
      initial_value: (Object.entries(data).length > 0 && data.external_organisation_unit_identifier !== null) ? data.external_organisation_unit_identifier : '',
      className: 'full'
    },

    date_range: {
      field: "date_range",
      label: "Validity Date Range",
      className: "full",
      date_range_fields: {
        valid_from_date:{
          field: "date",
          label: "Valid From",
          required: true,
          validation: "date|required",
          disable: allowEdit,
          past: !(Object.entries(data).length > 0 && data.valid_from_date),
          initial_value: Object.entries(data).length > 0 ?  data.valid_from_date : '',
        },
        valid_to_date:{
          field: "date",
          label: "Valid To",
          required: true,
          validation: "date|required",
          disable: allowEdit,
          past: !(Object.entries(data).length > 0 && data.valid_to_date),
          initial_value: Object.entries(data).length > 0 ? data.valid_to_date : '',
        }
      },
    },
    type_id_update_type: {
      field: "select",
      multi: false,
      option: "types",
      limiter: 'category_id||11',
      label: "Update Type",
      required: true,
      disable: allowEdit,
      validation: "integer|required",
      initial_value: (Object.entries(data).length > 0 && data.type_id_update_type !== null) ? data.type_id_update_type : '',
      className: 'full'
    },
    status_id: {
      field: "select",
      multi: false,
      option: [
        {id: 1, name: "Active", code: "ACTIVE"},
        {id: 2, name: "Disabled", code: "DISABLED"},
        {id: 3, name: "Archived", code: "ARCHIVED"},
        {id: 4, name: "Soft Archived", code: "SOFT-ARCHIVED"},
      ],
      label: "Status",
      required: true,
      disable: allowEdit,
      validation: "integer|required",
      initial_value: Object.entries(data).length > 0 ? data.status_id : '',
      className: 'full'
    },
  };
};